import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";
import back from "../../back.png";
import InputPassword from "../../helpers/InputPassword";
import InputCombo from "../../helpers/InputCombo";
import InputText from "../../helpers/InputText";

import MenuTable from "../../helpers/MenuTable";

import InputUploader from "../../helpers/InputUploader";

function KSeF(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [row, setRow] = useState({
        pem_crt: '',
        pem_key: '',
        pass: '',
        token: '',
    }); 
    const [tab, setTab] = useState(null); 

    const [view, setView] = useState('list'); 

    const [passOk,setPassOk] = useState(0);

    const [ksefLogs, setKsefLogs] = useState("dfsdf");

    

    const valChangeListener = (filedName, val, correct, msg) => {   
        
            
                //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
              
            
                row[filedName] = val;
                row[filedName+"_valid"] = correct;         
 
                setRow(  JSON.parse(JSON.stringify(row)) );    
             
            } 

        const onBack = ( ) => {                
                
            }


        const onSuccess = ( ) => {                
                
                getKSEF();
        }


        const getKSEF = () => {
                    
            
                    props.mainView.showProgress();

                    fetch( Config.url + '/rest_v1,ksef', {
                        method: 'POST', 
                        body: JSON.stringify( ), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                                 props.mainView.hideProgress();

                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                }else    
                                {
                                    setTab(res.result);                                                 
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                props.mainView.hideProgress();
                    });
                            

                    return false;
                }


  const checkPass = () => {
                    
       setPassOk('0');

                    props.mainView.showProgress();


                    fetch( Config.url + '/rest_v1,ksef_check', {
                        method: 'POST', 
                        body: JSON.stringify(  row ), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                                 props.mainView.hideProgress();

                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                }else    
                                {
                                    if(res.status == 'OK')                                  
                                    {
                                        if(res.result == '0') 
                                        {
                                            props.mainView.showDialog( "Ups!","Hasło klucza prywatnego jest nieprawidłowe." , "error" , null);  
                                        }

                                        if(res.result == '1') 
                                        {
                                            props.mainView.showDialog( "Sukces","Hasło prawidłowe :) " , "error" , null);  
                                            setPassOk('1');
                                        }
                                    }
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                props.mainView.hideProgress();
                    });
                            

                    return false;
                }                


  const goAdd = () => {
                    
       

                    props.mainView.showProgress();


                    fetch( Config.url + '/rest_v1,ksef_save', {
                        method: 'POST', 
                        body: JSON.stringify(  row ), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                                 props.mainView.hideProgress();

                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                }else    
                                {
                                    if(res.status == 'OK')                                  
                                    {
                                      getKSEF();
                                      setView("list");
                                    }
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                props.mainView.hideProgress();
                    });
                            

                    return false;
                }                


  const remove = (id) => {
                    
       

                    props.mainView.showProgress();


                    fetch( Config.url + '/rest_v1,ksef_remove', {
                        method: 'POST', 
                        body: JSON.stringify(  {id: id} ), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                                 props.mainView.hideProgress();

                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                }else    
                                {
                                    if(res.status == 'OK')                                  
                                    {
                                      getKSEF();
                                    
                                    }
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                props.mainView.hideProgress();
                    });
                            

                    return false;
                }                


  const checkKsef = (id) => {
                    
       

                    props.mainView.showProgress();


                    fetch( Config.url + '/rest_v1,ksef_ver', {
                        method: 'POST', 
                        body: JSON.stringify(  {id: id} ), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                                 props.mainView.hideProgress();

                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                }else    
                                {
                                    if(res.status == 'OK')                                  
                                    {
                                         getKSEF();
                                         props.mainView.showDialog( "Sukces",  "Wszystko jest w porządku!" , "error" , null);                                      
                                    }else 
                                    {
                                        props.mainView.showDialog( "Błąd",  res.param , "error" , (resp) => {
                                                setKsefLogs(res.logs);  
                                        } );   
                                         
                                    }
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                props.mainView.hideProgress();
                    });
                            

                    return false;
                }  


        const valChecker = (fields) => {

        var allValid = true;

              
        console.log(JSON.stringify(fields) );

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                if(Config.env == 'dev') console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }


       const validate = (pw) => { 

        return /[A-Z]/.test(pw) &&
        /[a-z]/       .test(pw) &&
        /[0-9]/       .test(pw) &&
        /[^A-Za-z0-9]/.test(pw) &&
        pw.length > 5;

        
      };


      const completeUpload = (fileName, crypt, param, typ) => {

         console.log("completeUpload " + fileName + " " + crypt + ", " + typ);
      
        
        
         if(typ == 'crt')
         {
                row['pem_crt'] = param.txt;
                row["pem_crt_valid"] = true;         
 
                setRow(  JSON.parse(JSON.stringify(row)) );   

                setPassOk(0);
         }

         if(typ == 'key')
         {
                row['pem_key'] = param.txt;
                row["pem_key_valid"] = true;         
 
                setRow(  JSON.parse(JSON.stringify(row)) );   

                setPassOk(0);
         }

    }



        const saveData = () => {
             
 
             if(!valChecker(row))
                {
                        props.mainView.showDialog("Ups!" , "Wypełnij prawidłowo pola formularza"  ,  "error"  ,null); 
                        return;
                }
                
 

                  props.mainView.showProgress();
 

                    fetch( Config.url + '/rest_v1,ksef_update', {
                        method: 'POST', 
                        body: JSON.stringify(row), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                            
                                props.mainView.hideProgress();

                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                }else    
                                {
                                    props.mainView.showDialog( "Sukces",  "Dane zostały zapisane.", "ok" , (pp)=>{
                                           
                                    } );                                                  
                                                                
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                props.mainView.hideProgress();
                    });
                        


                

                return false;
            }


        if(refreshView != props.userData.refreshView)
        {     
            setRefreshView(props.userData.refreshView);       
            getKSEF();
        }



        if(tab == null)
        {
            setTab([]);
            getKSEF();
            return <div>
                ...
            </div>
        }

     

        

    
        if(view == 'new')
        {
                        return <div className="view_content">

                                    <div className="app_header">Nowy certyfikat KSEF</div>

                                    <form className="eForm bg_center">

                                      


                                            <div className="form_tab">
                                                            <div className="form_control">
                                                                <div className="fieldName">Certyfikat crt</div>
                                                                 <InputUploader   userData={props.userData}  typ=".crt" typId={ -1 } remove="0" completeUpload={ (fileName, crypt, param)=>{ completeUpload(fileName, crypt,param, "crt") } } title={"kliknij tutaj i wybierz plik .crt"} max_files="1" ext="*.crt" />                               

                                                                 {
                                                                    row.pem_crt.length > 10 &&
                                                                    <textarea value={row.pem_crt} />
                                                                 }
                                                            </div>                                                        
                                            </div>

                                             <div className="form_tab">
                                                            <div className="form_control">
                                                                <div className="fieldName">Klucz prywatny</div>
                                                                 <InputUploader   userData={props.userData}  typ=".key" typId={ -1 } remove="0" completeUpload={ (fileName, crypt, param)=>{ completeUpload(fileName, crypt,param, "key") } } title={"kliknij tutaj i wybierz plik .key"} max_files="1" ext="*.key" />                               

                                                                 {
                                                                    row.pem_key.length > 10 &&
                                                                    <textarea value={row.pem_key} />
                                                                 }
                                                            </div>                                                        
                                            </div>

                                            <div className="form_tab">
                                                            <div className="form_control">
                                                                <div className="fieldName">Hasło dla klucza prywatnego</div>
                                                                <InputPassword   userData={props.userData} value={row.pass} err={null}  valChange={valChangeListener} goNext={null} name="pass" placeholder={"Nowe hasło:"} className=' w300 ' req='0' firstUp="0" />

                                                                {
                                                                    row.pem_crt.length > 10 && row.pem_key.length > 10 && row.pass.length > 2 &&
                                                                    <span className="link_color" onClick={checkPass}>sprawdź hasło</span>
                                                                } 
                                                            </div>                                                        
                                            </div>


                                    

                                            <div className="form_split"></div>

                                            <div className="form_btn">
                                                        <div className="btn" onClick={()=>{ setView('list');}}>anuluj</div>    
                                                        &nbsp; &nbsp;         
                                                        {
                                                            passOk == '1' && 
                                                            <div className="btn" onClick={goAdd}>dodaj certyfikat</div>  
                                                        }                          
                                                                                             
                                            </div>




                                    </form>

                        </div>
        }

         if(view == 'newt')
        {
                        return <div className="view_content">

                                    <div className="app_header">Nowy Token KSEF</div>

                                    <form className="eForm bg_center">

                                      


                                            <div className="form_tab">
                                                         <div className="form_control">
                                                                <div className="fieldName">Token</div>
                                                                <InputText   userData={props.userData} value={row.token} err={null}  valChange={valChangeListener} goNext={null} name="token" placeholder={"Token:"} className=' w400 ' req='0' firstUp="0" />                                                              
                                                            </div>                                                       
                                            </div>
 
                                    

                                            <div className="form_split"></div>

                                            <div className="form_btn">
                                                        <div className="btn" onClick={()=>{ setView('list');}}>anuluj</div>    
                                                        &nbsp; &nbsp;         
                                                        {
                                                            row.token.length > 10 && 
                                                            <div className="btn" onClick={goAdd}>dodaj token</div>  
                                                        }                          
                                                                                             
                                            </div>




                                    </form>

                        </div>
        }

        var logs = null;

        if(ksefLogs.length > 10)
        {
            logs = <div className="dlg_window shadowx " >
                        <div className="dlg_title" >Logi KSEF</div>

                        <div style={{overflow:'scroll', height: 300}}>
                            {ksefLogs}
                        </div>

                             
                  
                                <div className="dlg_btn">
                                    <div className="btn" onClick={ ()=>{  setKsefLogs(''); } } >zamknij [esc]</div>     
                                </div>          
                      
            </div>
        }


        return <div className="view_content">
                <div className="app_header">Certyfikaty KSeF</div>


                    <div className="table_widget">
                              <div className="btn" onClick={ ()=>{ setView('new'); } }    > Dodaj certyfikat [+]</div>
                              &nbsp; &nbsp; 
                              <div className="btn" onClick={ ()=>{ setView('newt'); } }    > Dodaj token [+]</div>
                    </div>

                    <div className="bg_center">

                                       <table className="table"  >

                                           <thead>
                                                <tr className="header">                                                                                               
                                                   <td className="td_left">LP</td>
                                                   <td className="">Typ</td>
                                                   <td className="">Status</td>
                                                   <td className="">Podmiot / Kontekst</td>
                                                   <td className="td_right">Data utworzenia</td>
                                                   <td className="td_option"></td> 
                                                </tr>
                                            </thead>

                                             <tbody>

                                                   {
                                                        tab.map( (row, ix) => {

                                                                var rowStyle = " row ";
                                                                if(ix % 2 == 0 )rowStyle = " row2 ";

                                                                if(row.domyslny == '1') rowStyle += " color_show2 ";

                                                                return  <tr className={rowStyle}>                                                                                               
                                                                        <td className="gocenter">{ix+1}</td>
                                                                        <td className="gocenter">{row.typ}</td>
                                                                        <td className="gocenter">
                                                                            {row.domyslny == '1' && 'Domyślny'}
                                                                            {row.domyslny == '0' && 'Nieaktywny'}
                                                                        </td>
                                                                        <td className="gocenter">{row.nazwa} {row.nip}</td>
                                                                        <td className="gocenter">{row.created_at}</td>
                                                                           <MenuTable>
                                                                            <ul>
                                                                                    <li   onClick={ ()=>{checkKsef(row.id)} }   > Zweryfikuj połączenie </li>
                                                                                    <li   onClick={ ()=>{remove(row.id)} }   > Usuń </li>
                                                                            </ul>                                                                             
                                                                           </MenuTable>
                                                                        </tr>
                                                        })
                                                   }

                                             </tbody>

                                       </table>
                    </div>


                    {logs}
        </div>
}


export default KSeF;